<template>
  <section v-if="imageSrc || isEditing" :id class="container">
    <PanoramaScroller v-if="imageSrc" :image="imageSrc" :link="link" />
  </section>
</template>

<script lang="ts" setup>
const props = defineProps<{
  roundshotId?: string
  roundshotLink?: string
}>()

const isEditing = false

const { index, siblings } = defineBlokkli({
  bundle: 'webcam',
  globalOptions: ['bkHiddenGlobally', 'publicationChannels'],
})
const id = useParagraphAnchorId(index, siblings)

const roundshotStyle = 'medium' // 'centerprev' was also used previously for inside the Navbar.

const imageSrc = computed(() => {
  return props.roundshotId
    ? `https://backend.roundshot.com/cams/${props.roundshotId}/${roundshotStyle}`
    : undefined
})

const link = computed(() => {
  if (props.roundshotLink) {
    switch (props.roundshotLink) {
      case 'nzz':
        return 'https://nzz.roundshot.com/#/'
      case 'uetliberg':
        return 'https://uetliberg.roundshot.com/#/'
      default:
        return 'https://zuerichtourismus.roundshot.com/' + props.roundshotLink
    }
  }

  return undefined
})
</script>
